<template>
  <div id="standard-video-player">
    <video ref="video" :autoplay="autoplay" class="video-js vjs-default-skin vjs-16-9 vjs-big-play-centered" controls>
      <source :src="sourceUrl" :type="type" />
    </video>
  </div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
import "videojs-seek-buttons";
import "./videoJsHotkeys";
import "../../../../bower_components/video.js/dist/video-js.min.css";

export default {
  props: {
    sourceUrl: { type: String, required: true },
    autoplay: { type: Boolean, default: false },
    seekButtons: { type: Boolean, default: true },
    type: { type: String, default: "application/x-mpegURL" },
  },

  mounted() {
    const videoElement = this.$refs.video;

    if (this.autoplay) {
      const style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = `
        .vjs-default-skin.vjs-paused .vjs-big-play-button {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    }

    this.player = videojs(videoElement, {
      autoplay: this.autoplay,
      playbackRates: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2],
      plugins: this.plugins,
    });

    this.player.on("pause", (event) => {
      if (this.isOffScreen()) {
        this.$emit("pause");
      }
    });
  },

  computed: {
    plugins() {
      return this.seekButtons
        ? {
          hotkeys: {
            seekStep: 5,
          },
          seekButtons: {
            forward: 5,
            back: 5,
          },
        }
        : undefined;
    },
  },

  methods: {
    isOffScreen() {
      const rect = this.$refs.video.getBoundingClientRect();
      return rect.bottom == 0 && rect.top == 0;
    },
  },

  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style lang="scss">
#standard-video-player .video-js .vjs-remaining-time,
#standard-video-player .video-js .vjs-seek-to-live-control,
#standard-video-player .video-js .vjs-picture-in-picture-control {
  display: none !important;
}

#standard-video-player .video-js .vjs-current-time {
  display: block !important;
}

#standard-video-player .video-js .vjs-playback-rate .vjs-playback-rate-value {
  font-size: 15px !important;
}

#standard-video-player .video-js .vjs-button>.vjs-icon-placeholder:before,
#standard-video-player .video-js .vjs-seek-button {
  font-size: 18px !important;
}

#standard-video-player .video-js .vjs-seek-button {
  font-family: 'VideoJS';
  cursor: pointer;
  font-weight: 400;
  font-style: normal;
  width: 62px;
  height: 30px;
}

#standard-video-player .video-js .vjs-seek-button.skip-back::before,
#standard-video-player .video-js .vjs-seek-button.skip-forward::before {
  content: '\f116';
}

#standard-video-player .video-js .vjs-seek-button.skip-back {
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

#standard-video-player .video-js .vjs-seek-button.skip-forward {
  transform: scale(-1, 1) rotate(-45deg);
  -ms-transform: scale(-1, 1) rotate(-45deg);
  -webkit-transform: scale(-1, 1) rotate(-45deg);
}
</style>
